import type { FaireProductEntity } from "../../entity_types/product";

export const p_mnubrpyau7: FaireProductEntity = {
  token: "p_mnubrpyau7",
  type: "product",
  name: "A’ Siciliana Sicilian Aranciata Blood Orange Soda 11.15oz",
  brandToken: "b_vsezuurgak",
  brandName: "Made in eatalia",
  imageUrl:
    "https://cdn.faire.com/fastly/fc6462e8f6141cc6af34848e7eb0d2a85ca5f997bc857e7a713770f30e2f8eda.jpeg",
  galleryImageUrls: [],
  priceDollars: 3.09,
  description:
    "\nThe Blood Orange is a variety of orange with crimson, almost-blood-colored flesh. The fruit is roughly the same size as an average orange, but sometimes can be smaller or larger; its skin is usually pitted, but can be smooth. The distinctive dark flesh color is due to the presence of anthocyanin, a family of antioxidant pigments common to many flowers and fruit, but uncommon in citrus fruits. Blood oranges have a unique flavor profile compared to other oranges, being distinctly raspberry-like in addition to the usual citrus notes. The arancia rossa di Sicilia (red orange of Sicily) has protected geographical status.\n\n330ml\n",
  tags: [],
  msrpDollars: 5.39,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:10.002Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
